import { usePageTitle } from '../hooks/usePageTitle'

const PrivacyPolicyPage = () => {
    usePageTitle('Privacy Policy | Mynexo')
    return (
        <main className="main">
            <div className="container">
                <section className="policy-page">
                    <div className="policy-card">
                        <h1 className="policy-title">Privacy Policy</h1>
                        <p className="policy-date">Last updated: March 2026</p>

                        <div className="policy-content">
                            <h2>1. Introduction</h2>
                            <p>
                                At Mynexo, we take your privacy seriously. This Privacy Policy explains how we collect,
                                use,
                                and protect your personal information when you use our social gaming platform.
                            </p>

                            <h2>2. Information We Collect</h2>
                            <p>
                                We may collect the following types of information:
                            </p>
                            <ul>
                                <li>Account information (display name, email address)</li>
                                <li>Game activity and virtual Credits history</li>
                                <li>Device information and browser type</li>
                                <li>IP address and general location</li>
                                <li>Communication preferences</li>
                            </ul>

                            <h2>3. How We Use Your Information</h2>
                            <p>
                                We use your information to:
                            </p>
                            <ul>
                                <li>Provide and maintain our gaming services</li>
                                <li>Track your virtual Credits and game history</li>
                                <li>Improve our platform and user experience</li>
                                <li>Communicate with you about updates and features</li>
                                <li>Ensure fair play and prevent abuse</li>
                            </ul>

                            <h2>4. Data Storage</h2>
                            <p>
                                Your game data, including virtual Credits and play history, is stored locally in your
                                browser
                                using localStorage. This data remains on your device and is not transmitted to our servers
                                unless you choose to create an account.
                            </p>

                            <h2>5. Cookies</h2>
                            <p>
                                We use cookies and similar technologies to remember your preferences, maintain your session,
                                and improve your experience on our platform.
                            </p>

                            <h2>6. Third-Party Sharing</h2>
                            <p>
                                We do not sell, trade, or share your personal information with third parties for their
                                marketing purposes. We may share information with service providers who help us operate our
                                platform.
                            </p>

                            <h2>7. Data Security</h2>
                            <p>
                                We implement appropriate security measures to protect your information. However, no method
                                of
                                transmission over the Internet is 100% secure, and we cannot guarantee absolute security.
                            </p>

                            <h2>8. Your Rights</h2>
                            <p>
                                You have the right to:
                            </p>
                            <ul>
                                <li>Access your personal information</li>
                                <li>Correct inaccurate data</li>
                                <li>Request deletion of your account</li>
                                <li>Opt out of communications</li>
                            </ul>

                            <h2>9. Children's Privacy</h2>
                            <p>
                                Mynexo is intended for users 18 years and older. We do not knowingly collect information
                                from anyone under 18 years of age.
                            </p>

                            <h2>10. Changes to This Policy</h2>
                            <p>
                                We may update this Privacy Policy from time to time. We will notify you of any changes by
                                posting the new policy on this page.
                            </p>

                            <h2>11. Contact Us</h2>
                            <p>
                                If you have questions about this Privacy Policy, please contact us at <a
                                    href="/cdn-cgi/l/email-protection" className="__cf_email__"
                                    data-cfemail="244d4a424b64574c4b4143454941570a474b49">info@mynexo.org.</a>.
                            </p>
                        </div>
                    </div>
                </section>
            </div>
        </main>
    )
}

export default PrivacyPolicyPage